import { render, staticRenderFns } from "./AutoPriceSettings.vue?vue&type=template&id=4ba3bcf6"
import script from "./AutoPriceSettings.vue?vue&type=script&lang=js"
export * from "./AutoPriceSettings.vue?vue&type=script&lang=js"
import style0 from "./AutoPriceSettings.vue?vue&type=style&index=0&id=4ba3bcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports